<template>
  <div class="update-page">
    <section class="update-section">
      <h2>今日更新漫画列表</h2>
      <div class="works-list">
        <div class="work-card" v-for="item in works" :key="item.id" @click="goDetail(item.id)">
          <img :src="item.cover" class="work-cover" />
          <div class="work-info">
            <h3>{{ item.title }}</h3>
            <p>作者：{{ item.author }}</p>
            <p class="desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getUpdateComics, BASE_URL } from '../api/index';
import youthModeManager from '@/utils/youthMode';

export default {
  name: 'UpdatePage',
  data() {
    return {
      works: []
    }
  },
  created() {
    this.fetchUpdateData();
  },
  methods: {
    async fetchUpdateData() {
      try {
        await youthModeManager.ensureReady();
        const res = await getUpdateComics({ page: 1, limit: 100 });
        if (res.data && res.data.code === 1) {
          this.works = youthModeManager.filterForYouth(res.data.data.list).map(item => ({
            id: item.id,
            cover: item.cover.startsWith('http') ? item.cover : BASE_URL + item.cover,
            title: item.title,
            author: item.author,
            desc: item.description
          }));
        }
      } catch (e) { /* ignore */ }
    },
    goDetail(id) {
      this.$router.push({ name: 'ComicDetail', params: { id } });
    }
  }
}
</script>

<style scoped>
.update-page {
  width: 100%;
  min-height: 100%;
  background: var(--bg);
  position: relative;
}

.update-section {
  background: var(--surface);
  border: 1px solid var(--border);
  margin: 20px 0;
  border-radius: 12px;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 22px;
  font-weight: bold;
  color: var(--text);
  padding: 30px;
}

.update-section::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 22px;
  background: var(--brand);
  border-radius: 2px;
  margin-right: 10px;
  vertical-align: middle;
}
.works-list {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: auto;
  gap: 15px;
  margin-top: 20px;
  width: 100%;
}
.work-card {
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform var(--t-fast), border-color var(--t-fast);
  cursor: pointer;
  min-width: 0;
  width: 100%;
}

.work-card:hover {
  transform: translateY(-5px);
  border-color: var(--brand-soft);
}
.work-cover {
  width: 100%;
  height: 140px;
  object-fit: cover;
  border-radius: 6px;
  margin-bottom: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.work-info {
  text-align: center;
  width: 100%;
}
.work-info h3 {
  font-size: 13px;
  margin: 0 0 3px 0;
  font-weight: 600;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.work-info p {
  font-size: 11px;
  margin: 0 0 2px 0;
  color: var(--text-dim);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.work-info .desc {
  color: var(--text-dim);
  font-size: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

/* 响应式设计 */
@media (max-width: 1600px) {
  .works-list {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (max-width: 1200px) {
  .works-list {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (max-width: 768px) {
  .works-list {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }
  .work-cover {
    height: 120px;
  }
  .work-info h3 {
  font-size: 12px;
  }
  .work-info p {
    font-size: 10px;
  }
  .work-info .desc {
    font-size: 9px;
  }
}
@media (max-width: 480px) {
  .works-list {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  .work-cover {
    height: 100px;
  }
  .work-info h3 {
    font-size: 11px;
  }
  .work-info p {
    font-size: 9px;
  }
  .work-info .desc {
    font-size: 8px;
  }
}
</style> 